export enum LoggerEventNames {
    BEACON_ERROR = 'chromecast.receiver.beacon.error',
    MEDIA_LOAD_FAILED = 'chromecast.receiver.media.load.failed',
    MEDIA_LOAD_INVALID = 'chromecast.receiver.media.load.invalid'
}
